import { Sms } from "iconsax-react";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

export default function ResetPasswordPage() {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [success, setSuccess] = useState(false);
    const navigate = useNavigate();

    // test effect
    const [logo, setLogo] = useState(null);

    useEffect(() => {
        const testLogo = window.localStorage.getItem("PHARM_LOGO");
        if (!testLogo) {
            console.log("There is no logo use default");
            setLogo("/clinic/images/vitalrx-logo.png");
        } else {
            console.log("there is logo");
            setLogo("/clinic/images/vitalrx-logo.png");
        }
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setErrorMessage("");

        // Basic validation
        if (!email) {
            setErrorMessage("Please enter your email address");
            setLoading(false);
            return;
        }

        // Placeholder for form submission
        setTimeout(() => {
            setSuccess(true);
            setLoading(false);
        }, 2000);
    };

    return (
        <div className="min-h-screen flex">
            {/* Left Section - Reset Password Form */}
            <div className="flex-1 bg-white flex flex-col px-8 lg:px-16 xl:px-24">
                <div className="max-w-md mx-auto w-full py-8 flex flex-col justify-center min-h-screen">
                    {/* Logo */}
                    <div className="mb-8">
                        <img src={logo} className="w-32 h-auto" alt="Pharmacy logo" />
                    </div>

                    {/* Main Content */}
                    {success ? (
                        <div className="text-gray-600 text-center">
                            <div className="text-lg font-medium mb-2">Check your email</div>
                            <div className="text-sm mb-6">
                                We've sent a password reset link to <strong>{email}</strong>.
                                Please check your email and click the link to reset your password.
                            </div>
                            <div className="space-y-3">
                                <Link
                                    to="/auth/extras/vitalRx/login"
                                    className="inline-block bg-[#007b7d] text-white py-3 px-6 rounded-lg font-medium hover:bg-[#005a5c] transition-colors"
                                >
                                    Back to Login
                                </Link>
                                <div className="text-xs text-gray-500">
                                    Didn't receive the email? Check your spam folder or{" "}
                                    <button
                                        onClick={() => setSuccess(false)}
                                        className="text-[#007b7d] hover:underline"
                                    >
                                        try again
                                    </button>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <>
                            <div className="mb-8">
                                {/* <h1 className="text-2xl font-bold text-gray-900 mb-2">
                                    Reset your password
                                </h1> */}
                                <p className="text-gray-600 text-sm">
                                    Enter your email address and we'll send you a link to reset your password.
                                </p>
                            </div>

                            {/* Reset Password Form */}
                            <form onSubmit={handleSubmit} className="space-y-4">
                                {/* Email Field */}
                                <div>
                                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                                        Email address
                                    </label>
                                    <div className="relative">
                                        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                            <Sms size={16} className="text-gray-400" />
                                        </div>
                                        <input
                                            id="email"
                                            type="email"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            className="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#007b7d] focus:border-transparent outline-none transition-colors"
                                            placeholder="Enter your email address"
                                            required
                                        />
                                    </div>
                                </div>

                                {/* Error Message */}
                                {errorMessage && (
                                    <div className="text-red-500 text-sm font-medium">
                                        {errorMessage}
                                    </div>
                                )}

                                {/* Submit Button */}
                                <button
                                    type="submit"
                                    disabled={loading || !email}
                                    className="w-full bg-[#007b7d] text-white py-3 px-4 rounded-lg font-medium hover:bg-[#005a5c] focus:ring-2 focus:ring-[#007b7d] focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                                >
                                    {loading ? "Loading..." : "Verify email"}
                                </button>
                            </form>

                            {/* Links */}
                            <div className="mt-6 space-y-3 text-center">
                                <div className="text-sm text-gray-600">
                                    Remember your password?{" "}
                                    <Link
                                        to="/auth/login"
                                        className="font-medium text-gray-900 hover:text-gray-700"
                                    >
                                        Sign in
                                    </Link>
                                </div>
                                {/* <div className="text-sm text-gray-600">
                                    Don't have an account?{" "}
                                    <Link
                                        to="/auth/extras/vitalRx/request_account"
                                        className="font-medium text-gray-900 hover:text-gray-700"
                                    >
                                        Request an account
                                    </Link>
                                </div> */}
                            </div>
                        </>
                    )}
                </div>
            </div>

            {/* Right Section - Background Image */}
            <div style={{ backgroundImage: "url('/clinic/images/authimg2.jpg')" }} className="hidden lg:flex lg:flex-1 relative bg-center bg-cover bg-no-repeat">
                <div className="absolute inset-0 bg-gradient-to-br from-[#007b7d]/70 via-[#005a5c]/60 to-black/80">
                    {/* Abstract shapes overlay */}
                    <div className="absolute inset-0">
                        <div className="absolute top-20 left-10 w-32 h-32 bg-[#007b7d]/20 rounded-full blur-xl"></div>
                        <div className="absolute top-40 right-20 w-24 h-24 bg-[#007b7d]/15 rounded-full blur-xl"></div>
                        <div className="absolute bottom-40 left-20 w-40 h-40 bg-[#005a5c]/25 rounded-full blur-xl"></div>
                        <div className="absolute bottom-20 right-10 w-28 h-28 bg-[#007b7d]/10 rounded-full blur-xl"></div>
                    </div>

                    {/* Mountain silhouette */}
                    <div className="absolute bottom-0 right-0 w-full h-32">
                        <svg viewBox="0 0 400 100" className="w-full h-full">
                            <path d="M0,100 L50,60 L100,80 L150,40 L200,70 L250,30 L300,50 L350,20 L400,40 L400,100 Z"
                                fill="rgba(0,123,125,0.4)" />
                        </svg>
                    </div>

               
                </div>
            </div>
            {/* Powered by */}
          <div className="absolute bottom-4 left-4 flex items-center gap-2 text-[#111111] text-xs">
            <span>Powered by</span>
            <img src="/clinic/images/logo-bw.png" className="w-24 h-auto" alt="BCRX" />
          </div>
        </div>
    );
}
